import { getObjectValue } from '@services/object-extensions';
import cn from 'classnames';
import styles from './sezione-principale.module.css';

const SezionePrincipale = ({ translations = {}, darkTheme = false }) => {
  return (
    <div
      className={cn(`row  align-items-center justify-content-center ${styles.textContainer}`, {
        'snf-text-color-white': darkTheme
      })}
    >
      <div className="col-12 col-md-10">
        <div className="row">
          <div className={`col-12 snf-font-32 snf-font-w6 ${styles.title}`}>
            {getObjectValue(translations, 'title', '')}
          </div>
        </div>
        <div className="row">
          <div className={`col-12 snf-font-20 ${styles.subtitle}`}>
            {getObjectValue(translations, 'subtitle', '')}
          </div>
        </div>
        <div className="row">
          <div className={`col-12 snf-font-16 ${styles.paragraph}`}>
            {getObjectValue(translations, 'paragraph', '')}
          </div>
        </div>
      </div>
    </div>
  );
};

SezionePrincipale.displayName = 'Inizio Pagina';
export { SezionePrincipale };
